import Vue from 'vue'
import Router from 'vue-router'

import Home from './views/Home.vue'
import Timeline from './views/Timeline.vue'
import Entry from './views/Entry.vue'
import EntryStandard from "./views/EntryStandard";

import Login from './views/Login.vue'

import FollowList from "./views/FollowList";
import Profile from "./views/Profile";

import ReportSearch from "./views/ReportSearch";
import Report from "./views/Report";

import DailyView from "./views/DailyView";
import EntryCheckView from "./views/EntryCheckView";

import ThanksCard from "@/views/ThanksCard";


Vue.use(Router);

const decodeNumberUrlQuery = function (v){
  if (v === undefined) return undefined;
  if (Number.isNaN(v)) return undefined;
  return Number(v);
};




const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta:{
        title: 'Home'
      },
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      props:(route) => ({
        propSSO:route.query.sso,
        propBackuri:route.query.backuri,
      }),
      meta: {
        isPublic: true ,
        title: 'Login'
      }
    },

    {
      path: '/timeline',
      name: 'timeline',
      component: Timeline,
      meta:{
        title: 'Timeline',
        useReload:true,
      },
    },

    {
      path: '/daily',
      component: DailyView,
      meta:{
        title: 'DailyView'
      },
    },


    {
      path: '/entrycheck',
      component: () => import(/* webpackChunkName: "entryCheckView" */ './views/EntryCheckView'),
      meta:{
        title: '入力確認'
      },
    },


    {
      path: '/search',
      component:ReportSearch,
      meta:{
        title: '日報検索'
      },
    },

    {
      path:'/report/:reportId',
      component:Report,
      props:(route) => ({
        reportId:route.params.reportId,
      }),
      meta:{
        title: '日報'
      },
    },

    {
      path: '/entry',
      name: 'entry',
      component: Entry,
      props:(route) => ({
        propReportDate:route.query.dt,
      }),
      meta:{
        title: '日報入力',
        scrollToTop:false,
      },
    },

    {
      path: '/entry_standard',
      component: EntryStandard,
      props:(route) => ({
        propReportId:Number(route.query.id),
        propReportDate:route.query.dt,
      }),
      meta:{
        title: '日報入力',
        scrollToTop:false,
      },
    },

    {
      path:'/follows',
      component:FollowList,
      meta:{
        title: 'フォロー設定'
      },
    },

    {
      path:'/thanks/_self',
      component:ThanksCard,
      meta:{
        title: 'Thanks!カード'
      },
    },

    {
      path:'/profile',
      component:Profile,
      meta:{
        title: 'プロフィール',
        scrollToTop:false,
      },
    },

    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    }
  ]
});

export default router;
